import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import heroImage from "../Media/events/past/canadian-business.jpg";
import "./Topic.scss";

const Trade = () => {
  return (
    <>
      <NavBar />
      <main className="topic">
        <header className="topic__hero">
          <div className="container topic__heroInner">
            <div className="topic__heroText">
              <span className="eyebrow">Trade Missions &amp; Delegations</span>
              <h1 className="section-heading">
                Discover the Power of Trade Missions
              </h1>
              <p className="lede">
                Fostering success, building connections, and creating synergies
                through trade.
              </p>
              <Link to="/membership" className="btn btn--filled">Join Us Today</Link>
            </div>
            <div className="topic__heroImage">
              <img src={heroImage} alt="ANZEG at a university and Canadian Business Council collaboration" />
            </div>
          </div>
        </header>

        <section className="topic__body">
          <div className="container">
            <p className="lede">
              ANZEG plays a pivotal role in fostering the success of
              businesses in their local communities. Our influence extends
              beyond networking and resources; we serve as the backbone for
              local and international economic development and advocacy.
            </p>
            <p className="lede">
              Membership fees ensure that ANZEG can continue our vital work.
              Engaging in our trade missions can open doors for
              collaborations, partnerships, and international trade.
            </p>
          </div>
        </section>

        <section className="topic__about">
          <div className="container">
            <span className="eyebrow">How It Works</span>
            <h2 className="section-heading section-heading--sm">How Trade Missions Work</h2>
            <p className="lede">
              ANZEG provides access to a wide array of resources, supported
              by membership fees, including a directory, discounts, industry
              research, and leadership development programs. We also offer
              online tools and webinars to help businesses adapt to the
              digital age, with additional opportunities for international
              trade visits.
            </p>
          </div>
        </section>

        <section className="topic__benefits">
          <div className="container">
            <span className="eyebrow">Environment</span>
            <h2 className="section-heading section-heading--sm">Dynamic Economic Environment</h2>
            <ul className="marker-list">
              <li>
                A dynamic and rapidly growing economic environment for
                exploration and collaboration requires official invitations
                from the Ministries of Foreign Affairs to assist in Business
                Forums, aimed at attracting prominent corporations with
                ANZEG's counterparts to foster stronger economic ties.
              </li>
              <li>Missions are usually run in cooperation with embassies and other government entities.</li>
              <li>Events featured on these business trips include presentations and speeches from both nations with a focus on bilateral trade.</li>
              <li>Discussions on these delegations mostly cover agriculture, education, health, tourism, and finance, providing information for foreign investors from the public-private sectors.</li>
            </ul>
          </div>
        </section>

        <section className="topic__body">
          <div className="container">
            <span className="eyebrow">Discussion</span>
            <h2 className="section-heading section-heading--sm">Topics of Discussion</h2>
            <p className="lede">
              These missions often feature discussions on agriculture,
              education, health, tourism, and finance. Meetings provide
              invaluable insights for foreign investors from the
              public-private sectors.
            </p>
          </div>
        </section>

        <section className="topic__contact">
          <div className="container">
            <h2 className="section-heading section-heading--sm">Get in Touch</h2>
            <p className="lede">
              Interested in joining our next trade mission? Contact us for
              more details and collaboration opportunities.
            </p>
            <a href="mailto:info@anzeginstitute.org" className="btn btn--filled">Contact Us</a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Trade;
